import { useRef } from 'react';
import { useTheme } from '../../context/ThemeContext.jsx';

export default function UploadZone({ uploading, uploadProgress, uploadError, dragOver, setDragOver, onDrop, onFiles }) {
  const { theme } = useTheme();
  const fileInputRef = useRef(null);
  const folderInputRef = useRef(null);

  return (
    <div
      onDragOver={e => { e.preventDefault(); setDragOver(true); }}
      onDragLeave={() => setDragOver(false)}
      onDrop={onDrop}
      onClick={() => fileInputRef.current?.click()}
      style={{
        margin: '16px 24px 0', padding: 32,
        border: `2px dashed ${dragOver ? theme.accentBorderHover : theme.accentBorder}`,
        borderRadius: 12,
        background: dragOver ? theme.accentBg : theme.bgTertiary,
        textAlign: 'center', cursor: 'pointer', transition: 'all 0.2s',
      }}
    >
      <input
        ref={fileInputRef}
        type="file"
        multiple
        accept=".otf,.ttf,.woff,.woff2,.txt,.pdf,.html,.htm,.rtf,.md"
        onChange={e => onFiles(e.target.files)}
        style={{ display: 'none' }}
      />
      <input
        ref={folderInputRef}
        type="file"
        webkitdirectory=""
        multiple
        onChange={e => onFiles(e.target.files)}
        style={{ display: 'none' }}
      />
      {uploading ? (
        <>
          <div style={{ fontSize: 13, fontWeight: 600, color: theme.accent }}>
            Uploading {uploadProgress?.current}/{uploadProgress?.total} files...
          </div>
          <div style={{
            width: 200, height: 4, background: theme.bgInput,
            borderRadius: 2, margin: '12px auto 0', overflow: 'hidden',
          }}>
            <div style={{
              width: `${(uploadProgress?.current / uploadProgress?.total) * 100}%`,
              height: '100%', background: theme.accent, borderRadius: 2,
              transition: 'width 0.3s',
            }} />
          </div>
        </>
      ) : (
        <>
          <div style={{ fontSize: 28, marginBottom: 8, opacity: 0.5 }}>⬆</div>
          <div style={{ fontSize: 13, fontWeight: 600, color: theme.textSecondary }}>
            Drop files or a folder here
          </div>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8, marginTop: 10 }}>
            <button
              onClick={e => { e.stopPropagation(); fileInputRef.current?.click(); }}
              style={{
                padding: '5px 14px', fontSize: 11, fontWeight: 600,
                background: theme.bgInput, border: `1px solid ${theme.borderHover}`,
                borderRadius: 6, color: theme.textSecondary,
                cursor: 'pointer', fontFamily: 'inherit',
              }}
            >Browse Files</button>
            <button
              onClick={e => { e.stopPropagation(); folderInputRef.current?.click(); }}
              style={{
                padding: '5px 14px', fontSize: 11, fontWeight: 600,
                background: theme.bgInput, border: `1px solid ${theme.borderHover}`,
                borderRadius: 6, color: theme.textSecondary,
                cursor: 'pointer', fontFamily: 'inherit',
              }}
            >Browse Folder</button>
          </div>
          <div style={{ fontSize: 11, color: theme.textFaint, marginTop: 8 }}>
            .otf .ttf .woff .woff2 · License files (.txt .pdf .html) included automatically
          </div>
        </>
      )}
      {uploadError && (
        <div style={{ color: theme.red, fontSize: 12, marginTop: 8 }}>{uploadError}</div>
      )}
    </div>
  );
}
